"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredCard = void 0;
const tslib_1 = require("tslib");
const hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
const CSS = {
    container: 'c-CenteredCard',
    logo: 'c-CenteredCard__Logo',
    body: 'c-CenteredCard__Body',
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme_1.DefaultTheme.space(18)} ${theme_1.DefaultTheme.space(6)} ${theme_1.DefaultTheme.space(6)}`,
        margin: '20vh auto auto',
        backgroundColor: theme_1.DefaultTheme.background.offWhite,
        borderRadius: theme_1.DefaultTheme.space(1),
        border: `1px solid rgb(${theme_palette_1.ColorPaletteGrey.C300})`,
        minHeight: '400px',
        boxSizing: 'border-box',
    },
    [CSS.logo]: {
        width: '200px',
        paddingBottom: theme_1.DefaultTheme.space(12),
    },
    [CSS.body]: {
        width: '100%',
    },
});
exports.CenteredCard = {
    view(children, ctx = {}) {
        return (0, hyperscript_1.default)('div', { className: `mdl-card ${CSS.container} ${ctx.className || ''}` }, [
            (0, hyperscript_1.default)('img', { className: CSS.logo, src: (0, theme_1.assetPath)('/images/ike_logo_solid_dark.svg') }),
            (0, hyperscript_1.default)('div', { className: CSS.body }, children),
        ]);
    },
};
//# sourceMappingURL=centered.card.js.map